<div class="container align-items-center justify-content-center">
  <div class="row contact-hero align-items-start">
    <div class="col-lg-6 col-md-12">
      <div class="hero-content">
        <div class="eyebrow mb-2">Get in touch</div>
        <h1 class="headline mt-primary-text mb-2">Talk to our team about your member operations.</h1>
        <div class="audience mb-3">Questions? Talk to our team.</div>
        <p class="subheadline mt-primary-text mb-4">
          Whether you manage one organization or support several, we can map where MemberTrace replaces manual work across members, events, dues, and reporting.
        </p>
        <div class="founder-note">
          <strong>Founder-led walkthrough.</strong>
          You will get a practical conversation about fit, setup, and next steps instead of a generic vendor queue.
        </div>
        <div class="contact-info">
          <div class="contact-item">
            <mat-icon class="contact-icon">mail</mat-icon>
            <span class="contact-text">hello&#64;membertrace.com</span>
          </div>
          <div class="contact-item">
            <mat-icon class="contact-icon">call</mat-icon>
            <a href="tel:+13862276459" class="contact-text">386-227-6459</a>
          </div>
          <div class="contact-item">
            <mat-icon class="contact-icon">schedule</mat-icon>
            <span class="contact-text">Mon-Fri, 9AM-6PM EST</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-md-12 d-flex align-items-start contact-form-section mt-4 mt-lg-0">
      <app-contact-form></app-contact-form>
    </div>
  </div>
</div>
